// extracted by mini-css-extract-plugin
export default {"Title":"Matting_Title__MPdkV","Controller":"Matting_Controller__Sowbk","Content":"Matting_Content__i7R0u","DragAndScale":"Matting_DragAndScale__FbT0D","Tips":"Matting_Tips__M7rbQ"};